import React from 'react'
import { HomePageContent } from './HomePageContent';
import NewProductInformationTabContent from './HomePageTabs/NewProductInformationTabContent';
import ProductDocumentsTabContent from './HomePageTabs/ProductDocumentsTabContent';
import ProductListingTabContent from './HomePageTabs/ProductListingTabContent';
import ProductTabContent from './HomePageTabs/ProductTabContent';
import store from "../../storeWire";
import produceClone from "../../helper/produceClone";
import Product from "@system/config/product";
import HomePage from "@system/config/home-page";
import $ from "jquery";
import { isObject } from "underscore";

class Common {

    static chain = {
        HomePageContent: { param_value: 'PLT', element: HomePageContent }
    };
    static param_key = '__c';
    static redux_key = 'Home__Component__Loader';
    static default_component = Common.chain.HomePageContent;

    static chain_HomeTabList = {
        PLT: {
            name: 'Products',
            param_value: 'PLT',
            element: ProductListingTabContent,
            store: () => {
                return Common.getContentTabValueFromStore('productListingCount')
            }
        },
        /**
         * uncomment for ticket 13886
         * Author: Devanshi Patel
         * Ticket No: 11999 - HS
         */
        // Hide Content Tab
        NPIT: {
            name: 'New Product Information',
            param_value: 'NPIT',
            element: NewProductInformationTabContent,
            store: () => {
                return Common.getContentTabValueFromStore('npiCount')
            }
        },

        CNT: {
            name: 'Content',
            param_value: 'CNT',
            element: ProductTabContent,
            store: () => {
                return Common.getContentTabValueFromStore('contentCount')
            }
        },
        DCT: {
            name: 'Documents',
            param_value: 'DCT',
            element: ProductDocumentsTabContent,
            store: () => {
                return Common.getContentTabValueFromStore('documentCount')
            }
        }
    };

    static getContentTabValueFromStore(api_fetch_type) {
        let s = store.getState();
        if (api_fetch_type === 'productListingCount') {
            if (s.entities.ProductListingAPICall.data !== undefined &&
                s.entities.ProductListingAPICall.data['@odata.count'] !== undefined &&
                s.entities.ProductListingAPICall.data['@odata.count'] > 0
            ) {
                return {
                    count: s.entities.ProductListingAPICall.data['@odata.count']
                };
            }
        }
        if (api_fetch_type === 'contentCount' &&
            s.entities.model_HomePageContent !== undefined &&
            s.entities.model_HomePageContent.contentTabCount !== undefined &&
            s.entities.model_HomePageContent.contentTabCount.allCount !== undefined &&
            s.entities.model_HomePageContent.contentTabCount.allCount > 0
        ) {
            return {
                count: s.entities.model_HomePageContent.contentTabCount.allCount
            };
        }
        if (api_fetch_type === 'documentCount' &&
            s.entities.model_HomePageContent !== undefined &&
            s.entities.model_HomePageContent.documentContent !== undefined &&
            s.entities.model_HomePageContent.documentContent.count !== undefined &&
            s.entities.model_HomePageContent.documentContent.count > 0
        ) {
            return {
                count: s.entities.model_HomePageContent.documentContent.count
            };
        }
        if (s.entities.model_HomePageContent !== undefined &&
            s.entities.model_HomePageContent.allTabsCount !== undefined &&
            s.entities.model_HomePageContent.allTabsCount[api_fetch_type] !== undefined
        ) {
            return {
                count: s.entities.model_HomePageContent.allTabsCount[api_fetch_type]
            };
        }
        return {
            count: 0
        };
    }

    static param_key_HomeTabList = '__c_HomeTabList';
    static redux_key_HomeTabList = 'HomeTabList__Component__Loader';
    static default_component_HomeTabList = Common.chain_HomeTabList.PLT;

    static getTabLink(singleElement, c) {
        return HomePage.getHomeTabsListRouteURL({
            ...c,
            [Common.param_key_HomeTabList]: singleElement.param_value
        });
    };

    static getRedirectionURL(searchTerm, productList, allTabsCount, c, isRedirectToPDP = true) {
        if (searchTerm) {
            c.search = searchTerm.trimEnd().trimStart();
        }

        c.ComingFromUniversalSearch = 'yes';
        delete c.ERPPartNumber;
        delete c.ItemNumber;
        let allTabsCountH = produceClone(allTabsCount);
        let linkMade = null;

        if (isRedirectToPDP && isObject(productList) && Object.keys(productList).length === 1) {
            Object.keys(productList).map((p, i) => {
                if (linkMade === null) {
                    linkMade = Product.getProductDetailPageRouteURLWithCustomParameter(productList[p]) + '?ERPPartNumber=' + productList[p].ERPPartNumber + '&ItemNumber=' + productList[p].ItemNumber + '&searchTerm=' + searchTerm
                }
            });
        }
        if (isObject(productList) && Object.keys(productList).length === 0) {
            allTabsCountH.productListingCount = 0;
        }
        if (allTabsCountH.productListingCount === 0) {
            /** Ticket No: 11999 **/
            // Hide Content Tab
            if (linkMade === null && allTabsCountH.npiCount > 0) {
                linkMade = this.getTabLink(Common.chain_HomeTabList.NPIT, c);
            }
            if (linkMade === null && allTabsCountH.contentCount > 0) {
                linkMade = this.getTabLink(Common.chain_HomeTabList.CNT, c);
            }
            if (linkMade === null && allTabsCountH.documentCount > 0) {
                linkMade = this.getTabLink(Common.chain_HomeTabList.DCT, c);
            }
        }

        if (allTabsCountH?.allCount === 0) {
            delete c.go;
            delete c.search;
            localStorage.removeItem('product_listing_page')
            localStorage.removeItem('product_listing_limit')
            history.pushState(null, null, '?' + $.param(c));
            linkMade = Product.getProductListingNotFoundPageRouteURL() + '?' + $.param(c);
        }

        if (productList && Object.keys(productList).length > 1) {
            c.page = 1;
            c.__c_HomeTabList = ''
        }
        c.page = 1;
        if (linkMade === null) {
            linkMade = Product.getProductListingPageRouteURL() + '?' + $.param(c);
        }
        return linkMade;
    }
}

export default Common;